module.exports = __webpack_public_path__ + "img/honer5.bbcb1d38.jpg";